<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Категории') }}</h1>
                </div>

                <div class="categories-list">
                    <div :class="{'category-item': true, 'editing': category.edit && category !== true, 'deleting': category.deleting === true}" 
                        :id="`category-item-${category.id}`" 
                        @click="edit(category)" 
                        v-for="category in categories" 
                        :key="category.id">
                        <div class="category-item-container">
                            <div class="category-name-input-group">
                                <input type="text" :readonly="category.edit != true" class="form-control cagegory-icon" v-model="category.icon" placeholder="👻">
                                <input type="text" :readonly="category.edit != true" class="form-control category-name" v-model="category.title" :placeholder="$t('Введите название категории')">
                            </div>
                            <div class="category-controls">
                                <div class="checkbox-group mr-32">
                                    <input :id="`expenses-check-${category.id}`" v-model="category.expenses" type="checkbox">
                                    <label :for="`expenses-check-${category.id}`" class="checkbox-label">
                                        {{ $t('расходы') }}
                                    </label>
                                </div>
                                <div class="checkbox-group">
                                    <input :id="`incomes-check-${category.id}`" v-model="category.incomes" type="checkbox">
                                    <label :for="`incomes-check-${category.id}`" class="checkbox-label">
                                        {{ $t('доходы') }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="category-item-btns">
                            <button @click.prevent="cancel(category)" v-if="category.edit" class="category-cancel-btn btn btn-light"><i class="fas fa-times"></i> {{ $t('Отмена') }}</button>
                            <button @click.prevent="save(category)" v-if="category.edit" class="category-save-btn btn btn-blue">{{ $t('Сохранить') }}</button>
                            <button @click.prevent="deleteCategory(category)" v-if="! category.edit && category.key !== 'other'" class="category-delete-btn btn btn-light">{{ $t('Удалить') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-side-container sticky">
                <RightSideUserControls />

                <NewCategoryForm />
            </div>
        </div>
        
        <MobilePlusBtn type="new-category" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import NewCategoryForm from "@/new/components/Categories/NewCategoryForm.vue";
import { EventBus } from '../../../event-bus';

export default {
    name: "Categories",

    components: {
        RightSideUserControls,
        NewCategoryForm,
        MobilePlusBtn
    },

    watch: {
        'newCategory.title': function() {
            delete this.errors['title'];
        },
    },

    mounted() {
        this.loadCategories();
    },

    computed: {
        ...mapGetters(['categories', 'isCategoriesLoaded']),
    },
    
    methods: {
        ...mapActions(['loadCategories']),

        deleteCategory(category) {
            category.deleting = true;
            document.getElementById(`category-item-${category.id}`).classList.add('deleting');
            
            setTimeout(() => {
                this.categories = this.categories.filter((item, index) => item.id != category.id);

                axios.delete(`/categories/${category.id}`).then(({data}) => {
                        if(data.status == "success") {
                            this.loadCategories();

                            this.$ga.event('deleteCategoryButton', 'click', 'deleted');
                        }
                    }).catch(({response}) => {
                        console.log(response);

                        EventBus.$emit('show-alert', response.data.message, 'error');
                    });
            }, 500);
        },

        save(category) {
            if(! category.edit) {
                this.loadCategories();
            }

            category.edit = false;

            axios.patch(`/categories/${category.id}`, category).then(({data}) => {
                    if(data.status == "success") {
                        this.loadCategories();
                    }
                }).catch(({response}) => {
                    console.log(response);

                    EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        cancel(category) {
            category.edit = false;

            this.loadCategories();
            this.$forceUpdate();
        },

        edit(category) {
            if (document.body.clientWidth <= 768) {
                EventBus.$emit('open-side-form', 'edit-category', {
                        category, 
                        reload: () => {
                            this.$forceUpdate();
                        }
                    }
                );
            } else {
                category.edit = true;

                this.$forceUpdate();
            }
        },
    }
}
</script>

<style scoped lang="scss">
.right-side-container {
    @media (max-width: 768px) {
        display: none;
    }
}

.categories-list {
    width: 100%;
    padding-bottom: 24px;

    @media (max-width: 768px) {
        padding-top: 24px;
    }

    .category-item {
        width: calc(100% - 32px);
        background: rgba(#fff, .5);
        border-radius: 5px;
        padding: 16px;
        margin: 4px 0;
        display: flex;

        &.deleting {
            transform: translateX(-100%);
            opacity: 0;
            // height: 0;
            transition: 0.5s;
            margin: 0;
            padding: 0;
            margin-bottom: -82px;
        }

        &.editing {
            background: #fff;
            box-shadow: 0px 8px 10px rgba(63, 111, 183, 0.15);

            .category-cancel-btn {
                margin-bottom: auto;
            }
        }

        .category-item-btns {
            margin-left: auto;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            .btn {
                width: 80px;
                padding: 7px;
            }

            @media (max-width: 768px) {
                display: none;
            }
        }

        .category-item-container {
            display: flex;
            flex-direction: column;

            @media (max-width: 768px) {
                width: 100%;
            }

            .category-name-input-group {
                display: flex;
                align-items: center;

                .form-control {
                    font-size: 14px;
                    font-family: "Proxima Nova Lt";
                    font-weight: 600;
                    padding: 4px 8px;
                    margin-bottom: 12px;

                    &.cagegory-icon {
                        width: 24px;
                        padding: 4px;
                        text-align: center;
                        margin-right: 8px;
                        font-size: 12px;
                    }
                    
                    &.category-name {
                        min-width: 316px;

                        @media (max-width: 768px) {
                            min-width: auto;
                            width: 100%;
                        }
                    }
                }
            }
            
            .category-controls {
                display: flex;
                align-items: center;
                flex-direction: row;
            }
        }
    }
}
</style>